import { IcCheck } from './icons.js';
import './scenario.css';

interface MissionFinishFabProps {
  /** Todos los objetivos primarios cumplidos → CTA prominente "Ver mi cierre". */
  allDone: boolean;
  /** Cierra la sesión y navega al debrief (es el mismo `leave` del controller). */
  onFinish: () => void;
  /** Ancla a la columna de escritorio (.dt-main-conv) en vez del frame móvil. */
  desktop?: boolean;
  /**
   * Se oculta mientras la card de Inspire está abierta: flotan en la misma
   * esquina y el FAB quedaba ENCIMA de «Usar esto» — en el teléfono y en
   * escritorio angosto el toque terminaba la sesión (hallazgo #184).
   */
  hidden?: boolean;
}

/**
 * Botón flotante de cierre de una escena. Reemplaza el "Terminar" que vivía
 * enterrado dentro del panel desplegable del `MissionTracker` (confuso y
 * redundante con la X del header). Discreto mientras la misión está en curso;
 * se ilumina (lime + pop) cuando se completan todos los primarios, como cierre
 * natural. Nunca obliga a salir: la escena sigue abierta hasta que el user lo
 * toca o cierra con la X — puede seguir charlando. Ver docs/speak-plan/12 (A1).
 */
export function MissionFinishFab({
  allDone,
  onFinish,
  desktop = false,
  hidden = false,
}: MissionFinishFabProps) {
  if (hidden) return null;
  return (
    <button
      type="button"
      className={`mfab${allDone ? ' done' : ''}${desktop ? ' desktop' : ''}`}
      onClick={onFinish}
      aria-label={allDone ? 'Terminar y ver mi cierre' : 'Terminar la sesión'}
    >
      {allDone && (
        <span className="mfab-ic">
          <IcCheck size={15} />
        </span>
      )}
      <span className="mfab-tx">{allDone ? 'Ver mi cierre' : 'Terminar'}</span>
    </button>
  );
}
